import { store } from '../../../../resources/frontend/js/store/index';

export const formTranslation = (name) => {
  return store.state.page.translations['form-builder'][name];
};

export const storeLocatorTranslation = (name) => {
  return store.state.page.translations['store-locator'][name];
};

export const smsVerificationTranslation = (name) => {
  return store.state.page.translations['sms-verification'][name];
};

export const thankYouTranslation = (name) => {
  return store.state.page.translations['thank-you'][name];
};
